import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '../../../core/pipes/t.pipe';
import {
  STORE_HOTLINE_DISPLAY,
  STORE_HOTLINE_TEL_HREF,
  STORE_MOBILE_DISPLAY,
  STORE_MOBILE_TEL_HREF,
  STORE_WHATSAPP_HREF,
} from '../../../core/constants/store-contact';

interface SocialContactLink {
  kind: 'facebook' | 'phone' | 'whatsapp';
  iconUrl: string;
  labelKey: string;
  href: string;
  openInNewTab?: boolean;
  isCallChooser?: boolean;
}

/** Fixed WhatsApp / call / Facebook dock on every storefront page. */
@Component({
  selector: 'app-social-contact-rail',
  standalone: true,
  imports: [CommonModule, TranslatePipe],
  templateUrl: './social-contact-rail.component.html',
  styleUrls: ['./social-contact-rail.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SocialContactRailComponent {
  callChooserOpen = false;

  readonly mobileTelHref = STORE_MOBILE_TEL_HREF;
  readonly hotlineTelHref = STORE_HOTLINE_TEL_HREF;
  readonly mobileDisplay = STORE_MOBILE_DISPLAY;
  readonly hotlineDisplay = STORE_HOTLINE_DISPLAY;

  readonly links: SocialContactLink[] = [
    {
      kind: 'facebook',
      iconUrl: '/assets/icons/figma/social-rail-3.svg',
      labelKey: 'footer.facebook',
      href: 'https://www.facebook.com/people/Zerotech-Stores/61572042029705/',
      openInNewTab: true,
    },
    {
      kind: 'phone',
      iconUrl: '/assets/icons/figma/social-rail-2.svg',
      labelKey: 'footer.phone',
      href: STORE_MOBILE_TEL_HREF,
      isCallChooser: true,
    },
    {
      kind: 'whatsapp',
      iconUrl: '/assets/icons/figma/social-rail-1.svg',
      labelKey: 'footer.whatsapp',
      href: STORE_WHATSAPP_HREF,
      openInNewTab: true,
    },
  ];

  constructor(private readonly cdr: ChangeDetectorRef) {}

  onLinkClick(event: Event, social: SocialContactLink): void {
    if (!social.isCallChooser) return;
    event.preventDefault();
    this.callChooserOpen = true;
    this.cdr.markForCheck();
  }

  closeCallChooser(): void {
    this.callChooserOpen = false;
    this.cdr.markForCheck();
  }

  @HostListener('document:keydown.escape')
  onEscape(): void {
    if (!this.callChooserOpen) return;
    this.closeCallChooser();
  }
}
